import { userData } from "./userData";

export function handleCheckMetric(val, metrics) {
  if (userData?.userDetail?.role === "chiefAdmin") {
    return true;
  } else {
    return metrics?.some((item) => val === item);
  }
}

export function lastWords(words) {
  var n = words.split(" ");
  return n[n.length - 1];
}

export function firstWords(words) {
  var n = words.split(" ");
  return n[n.length - 2];
}
